"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { flushSync } from "react-dom";
import $ from "jquery";
import _ from "underscore";
import ActivityStreamHelper from "../helpers/activity_stream";
import AuditFlagReview from "./factoring/audit_flag_review";
import Api from "../api/api";
import CarrierService from "../services/carrier_service";
import classNames from "classnames";
import documentEditor from "./document_editor";
import DataStoreService from "./data_store_service";
import DocumentBrowser from "./react_document_browser";
import DocumentIndexerService from "./document_indexer_service";
import DocumentsService from "./documents_service";
import DocumentTypesSetter from "./indexer/document_types_setter";
import EmailHelper from "../helpers/email_message";
import FactorInvoice from "./indexer/factor_invoice";
import FactorInvoicesService from "./factor_invoices_service";
import ClientNotesSidebar, {
  ClientNotesSidebarTrigger
} from "./indexer/client_notes_sidebar";
import "../stores/factor_invoices_store";
import IndexerHeader from "./indexer/indexer_header";
import DocumentBrowserPagination from "../helpers/document_browser_pagination";
import PresenceList from "./presence";
import UnidentifiedDocumentHelper from "../helpers/unidentified_document";
import WaitingSpinner from "../components/waiting_spinner";
import {
  GroupedDocumentBrowserModel,
  DocumentBatchGroupCreator
} from "./grouped_document_browser_model";
import { IndexerProgress } from "./progress_bars";
import allowedAsPod from "../helpers/allowed_as_pod";
import hotkeys from "../util/hotkeys";
import { setPOD } from "../helpers/documents";
import { push } from "./app_history";
function getCarrier(invoice) {
  const activityCarrierIds = (invoice.activity_items || []).map((item) => {
    var _a, _b;
    return (_b = (_a = item.data) == null ? void 0 : _a.factor_invoice) == null ? void 0 : _b.carrier_id;
  }).filter((id) => id);
  const allCarrierIds = [
    .../* @__PURE__ */ new Set([invoice.carrier_id, ...activityCarrierIds])
  ];
  return Promise.all(
    allCarrierIds.map((id) => CarrierService.carrierWithId(id))
  ).then(
    (carriers) => carriers.find((carrier) => (carrier == null ? void 0 : carrier.id) === invoice.carrier_id)
  );
}
function findEmail(documentBatches) {
  return _.chain(documentBatches).pluck("email_message").first().value();
}
function factorInvoiceIdFromParams(params) {
  return params && params.factorInvoiceId && parseInt(params.factorInvoiceId);
}
function toggleMarkIllegibleData(document, page) {
  Api.DocumentPages.markIllegible(page);
}
function isSidebarFeatureEnabled(props) {
  if (props.embedded) return false;
  const settings = Api.Account.currentSettings();
  if (!settings) return false;
  const setting = settings["client_notes_sidebar_display"];
  return setting && setting !== "disabled";
}
function documentBatchId(props) {
  return props.params.batchId && parseInt(props.params.batchId);
}
function originalDocumentBatchId(props) {
  const query = props.location && props.location.query;
  if (query) {
    const next = query.next;
    if (next) {
      const matchResult = next.match(/\/index-document-batches\/(\d+)/);
      if (matchResult) {
        return matchResult[1];
      }
    }
  }
  return null;
}
function allPages(state) {
  return _.chain(state.documentModel.allDocuments()).map((d) => d.pages).flatten().value();
}
function currentPageIndex(state) {
  return _.findIndex(
    allPages(state),
    (p) => state.documentModel.selectedPage.id === p.id
  );
}
function activeDocuments(state) {
  return state.documentModel && state.documentModel.activeDocuments();
}
function allDocuments(state) {
  return state.documentModel && state.documentModel.allDocuments();
}
function isEditingDocumentType(state) {
  return state.editingDocumentType;
}
function hasMore(props) {
  return props.location.query["hasMore"] === "true" || props.params.hasMoreGroups === "true";
}
function didCompleteGroup(props) {
  if (props.onGroupCompleted) {
    props.onGroupCompleted();
  }
}
function batchUrl(props) {
  if (documentBatchId(props)) {
    let onDone = "/dashboard";
    if (props.location && props.location.query.onDone) {
      onDone = props.location.query.onDone;
    }
    return "/index-document-batches/" + documentBatchId(props) + "?onDone=" + encodeURIComponent(onDone);
  } else {
    return null;
  }
}
function invoiceActivityItems(state) {
  if (state.factorInvoice) {
    return state.factorInvoice.activity_items || [];
  } else {
    return [];
  }
}
function additionalBrowserComponents(state) {
  return _.compact([
    possibleMessageBrowserComponent(state),
    activityBrowserComponent(state)
  ]);
}
function possibleMessageBrowserComponent(state) {
  const emails = state.factorInvoice.email_messages || [];
  if (emails.length > 0)
    return {
      label: "Messages",
      component: EmailHelper.emailMessages(
        state.factorInvoice.email_messages,
        documentFromEmail(state)
      )
    };
}
function documentFromEmail(state) {
  if (state.factorInvoice && state.factorInvoice.state !== "approved") {
    return (emailMessage) => getDocumentFromEmail(state, emailMessage);
  }
}
function getDocumentFromEmail(state, emailMessage) {
  const model = state.documentModel;
  const groupId = model.selectedDocument.document_group_id;
  return documentEditor.documentFromEmail(emailMessage.id, groupId);
}
function activityBrowserComponent(state) {
  return {
    label: "Activity",
    component: ActivityStreamHelper.invoiceActivity(
      invoiceActivityItems(state)
    )
  };
}
function initialDocumentBrowserComponent(props) {
  return props.location.query.activeDocumentTab;
}
function header(props, state) {
  if (state.email) {
    return /* @__PURE__ */ jsx("div", { className: "document-indexer__header", children: /* @__PURE__ */ jsx(
      IndexerHeader,
      {
        email: state.email,
        actions: actions(props),
        ignoreEntry: () => ignoreEntry(props),
        canIgnoreEntry: !state.factorInvoice
      }
    ) });
  }
}
function ignoreEntry(props) {
  var onDone = props.location.query["onDone"] || "/dashboard";
  return Api.DocumentBatches.ignore(props.params.batchId).then(() => {
    push(onDone);
  }, _.identity);
}
function actions(props) {
  var actionList = [];
  const returnToBatchUrl = batchUrl(props);
  if (returnToBatchUrl) {
    actionList.push([
      "Return to Batch",
      () => {
        push(returnToBatchUrl);
      }
    ]);
  }
  return actionList;
}
class FactorInvoiceExtractDataPage extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleToggleSidebar", () => {
      this.setState((prevState) => ({ sidebarOpen: !prevState.sidebarOpen }));
    });
    __publicField(this, "updateData", (props, page) => {
      var buildDocumentModel = (documentBatches, invoiceId, stateDocumentModel) => {
        if (_.isEmpty(documentBatches)) return null;
        const currentPage = page || (stateDocumentModel ? stateDocumentModel.selectedPage : null);
        return new GroupedDocumentBrowserModel(
          DocumentBatchGroupCreator(documentBatches, function(doc) {
            return doc.factor_invoice_id === invoiceId;
          }),
          function() {
            return false;
          },
          currentPage
        );
      };
      var updateState = (documentModel, leftDocumentModel, invoice, documentBatches) => {
        const hasDocuments = !_.isEmpty(invoice.document_ids);
        const documentIndexerService = hasDocuments ? new DocumentIndexerService(
          {},
          DataStoreService,
          Api.Account,
          this.props.location
        ) : null;
        flushSync(() => {
          this.setState({
            documentModel,
            documentIndexerService,
            factorInvoice: invoice,
            documentBatches,
            email: findEmail(documentBatches),
            leftDocumentModel,
            loaded: true
          });
        });
      };
      var carrier = FactorInvoicesService.getWithId(props.params.factorInvoiceId).then((invoice) => {
        if (invoice.with_includes) {
          return Promise.resolve(invoice);
        }
        return FactorInvoicesService.fetchWithIDAndReturnPromise(invoice.id);
      }).then((invoice) => {
        DocumentsService.getDocumentBatches(
          invoice.document_batch_ids,
          (db) => db.documents
        ).then((documentBatches) => {
          documentBatches.forEach(
            (db) => DocumentsService.updateDocuments(db.documents)
          );
          updateState(
            buildDocumentModel(
              documentBatches,
              invoice.id,
              this.state.documentModel
            ),
            buildDocumentModel(
              documentBatches,
              invoice.id,
              this.state.leftDocumentModel
            ),
            invoice,
            documentBatches
          );
        });
        return invoice;
      }).then((invoice) => {
        return getCarrier(invoice);
      }).then((resolvedCarrier) => {
        this.setState({ carrierData: resolvedCarrier });
        this.resetViewAfterAddingDocument();
        return resolvedCarrier;
      });
      this.setState({ carrier });
    });
    __publicField(this, "resetViewAfterAddingDocument", () => {
      if (this.state.documentModel) {
        if (UnidentifiedDocumentHelper.setPageFromUnidentifiedDocument(
          this.state.documentModel
        )) {
          this.setState({ selectedComponent: "Documents" });
          this.editDocumentType();
          this.setState(
            { selectedComponent: "Documents" },
            () => this.setState({ selectedComponent: null })
          );
        }
      }
    });
    __publicField(this, "handlePageReplaced", (_event, page) => {
      if (page) {
        const currentPage = this.state.documentModel && this.state.documentModel.selectedPage;
        const isUpdatedVersionOfCurrentPage = currentPage && currentPage.document_id === page.document_id && currentPage.number === page.number;
        if (isUpdatedVersionOfCurrentPage) {
          this.updateData(this.props, page);
        } else {
          this.updateData(this.props);
        }
      }
    });
    __publicField(this, "handleDocumentBatchUpdated", (_event, _documentBatch) => {
      this.updateData(this.props);
    });
    __publicField(this, "handleDocumentGroupUpdated", (_event, _documentGroup) => {
      this.updateData(this.props);
    });
    __publicField(this, "toggleDocumentData", (document, field) => {
      if (field === "includesPOD") {
        setPOD(document, !document.is_pod);
      } else {
        document.data[field] = !document.data[field];
      }
      this.forceUpdate();
      const extras = field === "includesPOD" ? { pod_toggled: true } : void 0;
      Api.Documents.save(document, extras).then(() => {
        this.setState({ lastDocumentSaveTime: Date.now() });
        this.update();
      });
    });
    __publicField(this, "toggleClientDebtorOnBol", (invoice) => {
      this.setState({ saving: true });
      invoice.client_or_debtor_on_bol = !invoice.client_or_debtor_on_bol;
      this.forceUpdate();
      Api.FactorInvoices.toggleClientOrDebtorOnBol(
        invoice.id,
        invoice.client_or_debtor_on_bol,
        invoice.data.auditFlags
      ).then((_data) => {
        this.setState({ saving: false });
      });
    });
    __publicField(this, "goToPageAtIndex", (i) => {
      const desiredPage = allPages(this.state)[i];
      if (desiredPage) {
        this.state.documentModel.selectPage(desiredPage);
        this.forceUpdate();
      }
    });
    __publicField(this, "nextPage", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const pageIndex = currentPageIndex(this.state);
      if (pageIndex < 0) return;
      this.goToPageAtIndex(pageIndex + 1);
    });
    __publicField(this, "prevPage", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const pageIndex = currentPageIndex(this.state);
      if (pageIndex <= 0) return;
      this.goToPageAtIndex(pageIndex - 1);
    });
    __publicField(this, "togglePOD", (event) => {
      event.preventDefault();
      event.stopPropagation();
      const document = this.state.documentModel.selectedDocument;
      if (allowedAsPod(document)) {
        this.toggleDocumentData(document, "includesPOD");
      }
    });
    __publicField(this, "renderSidebar", () => {
      var _a;
      if (!isSidebarFeatureEnabled(this.props) || !this.state.carrierData) {
        return null;
      }
      return /* @__PURE__ */ jsx(
        ClientNotesSidebar,
        {
          warning: this.state.carrierData.warning || null,
          notes: this.state.carrierData.notes || null,
          fundingNotes: this.state.carrierData.funding_notes || null,
          verificationInstructions: this.state.carrierData.verification_instructions || null,
          isOpen: this.state.sidebarOpen,
          onToggle: this.handleToggleSidebar,
          loading: false,
          noteSettings: Api.Account.currentSettings()["client_notes_configuration"]
        },
        ((_a = this.state.carrierData) == null ? void 0 : _a.id) || "sidebar"
      );
    });
    __publicField(this, "mainContent", () => {
      if (this.state.reviewingAuditFlags) {
        return /* @__PURE__ */ jsxs("div", { className: "document-indexer__main-body load-detail__main", children: [
          this.renderSidebar(),
          /* @__PURE__ */ jsx(
            AuditFlagReview,
            {
              onCancel: this.cancelAuditFlagReview,
              onContinue: this.cancelAuditFlagReview,
              auditFlags: this.state.auditReview.auditFlags,
              factorInvoice: this.state.auditReview.factorInvoice,
              documentIds: this.state.auditReview.documentIds,
              model: this.state.documentModel,
              location: this.props.location
            }
          )
        ] });
      } else {
        return /* @__PURE__ */ jsxs("div", { className: "document-indexer__main-body load-detail__main", children: [
          this.renderSidebar(),
          this.factorInvoiceOrLeftSideBrowser(),
          this.props.embedded ? null : this.documentBrowser()
        ] });
      }
    });
    __publicField(this, "renderSidebarTrigger", () => {
      if (!isSidebarFeatureEnabled(this.props) || !this.state.carrierData) {
        return null;
      }
      return /* @__PURE__ */ jsx(
        ClientNotesSidebarTrigger,
        {
          warning: this.state.carrierData.warning || null,
          notes: this.state.carrierData.notes || null,
          fundingNotes: this.state.carrierData.funding_notes || null,
          verificationInstructions: this.state.carrierData.verification_instructions || null,
          onToggle: this.handleToggleSidebar,
          noteSettings: Api.Account.currentSettings()["client_notes_configuration"]
        }
      );
    });
    __publicField(this, "possibleIndexerProgressBar", () => {
      if (this.state.factorInvoice && this.state.factorInvoice.state !== "abandoned") {
        return /* @__PURE__ */ jsx(
          IndexerProgress,
          {
            stepNumber: 4,
            location: this.props.location,
            batchId: documentBatchId(this.props),
            sidebarTrigger: this.renderSidebarTrigger()
          }
        );
      }
    });
    __publicField(this, "changePage", (direction) => {
      DocumentBrowserPagination.changePage(this.state.documentModel, direction);
      this.forceUpdate();
    });
    __publicField(this, "update", () => {
      this.updateData(this.props);
    });
    __publicField(this, "openThumbnailLeft", (group, page) => {
      this.setState({ leftSelected: { group, page } });
    });
    __publicField(this, "closeLeftSideDocumentBrowser", () => {
      this.setState({ leftSelected: null });
    });
    __publicField(this, "typeComplete", () => {
      this.forceUpdate();
      this.setState({ editingDocumentType: false });
    });
    __publicField(this, "typeUpdate", (document) => {
      this.forceUpdate();
      Api.Documents.save(document);
    });
    __publicField(this, "factorInvoiceOrLeftSideBrowser", () => {
      if (this.state.browserExpanded) return null;
      const sidebarOpen = isSidebarFeatureEnabled(this.props) && this.state.carrierData && this.state.sidebarOpen;
      if (this.state.leftSelected) {
        const classes = classNames({
          "xlarge-4": !sidebarOpen,
          "small-5": !sidebarOpen,
          column: !sidebarOpen,
          "document-indexer__left-side-document-browser-area": true
        });
        return /* @__PURE__ */ jsx("div", { className: classes, children: /* @__PURE__ */ jsx("div", { className: "document-indexer__left-side-document-browser", children: /* @__PURE__ */ jsx(
          DocumentBrowser,
          {
            model: this.state.leftDocumentModel || {},
            leftSelected: true,
            closeBrowser: this.closeLeftSideDocumentBrowser,
            collapseSingleGroup: true,
            canEditDocumentType: false,
            allowsEditing: false,
            allowsEditingPodStatus: false
          }
        ) }) });
      } else {
        if (isEditingDocumentType(this.state)) {
          return this.documentSetter();
        } else {
          return this.factorInvoice();
        }
      }
    });
    __publicField(this, "documentSetter", () => {
      const sidebarOpen = isSidebarFeatureEnabled(this.props) && this.state.carrierData && this.state.sidebarOpen;
      const classes = classNames({
        "small-5": !sidebarOpen,
        "xlarge-4": !sidebarOpen,
        column: !sidebarOpen,
        "load-detail__action-area": true
      });
      return /* @__PURE__ */ jsx("div", { className: classes, children: /* @__PURE__ */ jsx(
        DocumentTypesSetter,
        {
          model: this.state.documentModel,
          onUpdate: this.typeUpdate,
          onComplete: this.typeComplete,
          documentIndexerService: this.state.documentIndexerService
        }
      ) });
    });
    __publicField(this, "factorInvoice", () => {
      const factorInvoiceId = factorInvoiceIdFromParams(this.props.params);
      const sidebarOpen = isSidebarFeatureEnabled(this.props) && this.state.carrierData && this.state.sidebarOpen;
      const classes = classNames({
        "small-5": !sidebarOpen,
        "xlarge-4": !sidebarOpen,
        column: !sidebarOpen,
        "load-detail__action-area": true
      });
      return /* @__PURE__ */ jsx("div", { className: classes, children: /* @__PURE__ */ jsx(
        FactorInvoice,
        {
          factorInvoiceId,
          model: this.state.documentModel,
          activeDocuments: activeDocuments(this.state),
          params: this.props.params,
          confirmAndSubmit: true,
          allDocuments: allDocuments(this.state),
          location: this.props.location,
          onDone: this.props.onDone,
          documentBatches: this.state.documentBatches,
          hasMore: hasMore(this.props),
          didCompleteGroup: this.props.onGroupCompleted ? () => didCompleteGroup(this.props) : void 0,
          onReviewAuditFlags: this.beginAuditFlagReview,
          continueWithoutInvoiceInformation: this.state.continueWithoutInvoiceInformation,
          onContinueWithoutInvoiceInformation: this.continueWithoutInvoiceInformation,
          carrier: this.state.carrier,
          lastDocumentSaveTime: this.state.lastDocumentSaveTime
        }
      ) });
    });
    __publicField(this, "beginAuditFlagReview", (factorInvoice, flags, documentIds) => {
      this.setState({
        auditReview: {
          auditFlags: flags,
          factorInvoice,
          documentIds
        },
        reviewingAuditFlags: true
      });
    });
    __publicField(this, "cancelAuditFlagReview", () => {
      this.setState({ reviewingAuditFlags: false, auditReview: void 0 });
    });
    __publicField(this, "continueWithoutInvoiceInformation", (shouldContinue) => {
      this.setState({ continueWithoutInvoiceInformation: shouldContinue });
    });
    __publicField(this, "editDocumentType", () => {
      this.setState({ editingDocumentType: true });
    });
    __publicField(this, "documentBrowser", () => {
      const sidebarOpen = isSidebarFeatureEnabled(this.props) && this.state.carrierData && this.state.sidebarOpen;
      const classes = classNames({
        "x-large-6": !this.state.browserExpanded && !sidebarOpen,
        "small-5": !this.state.browserExpanded && !sidebarOpen,
        "small-10": this.state.browserExpanded && !sidebarOpen,
        column: !sidebarOpen,
        "document-indexer__document-side": true
      });
      return /* @__PURE__ */ jsx("div", { className: classes, children: /* @__PURE__ */ jsx(
        DocumentBrowser,
        {
          model: this.state.documentModel || {},
          selectedComponent: this.state.selectedComponent,
          location: this.props.location,
          leftSelected: this.state.leftSelected,
          isConfirmAndSubmit: true,
          onContextMenu: this.openThumbnailLeft,
          canEditDocumentType: true,
          editDocumentType: this.editDocumentType,
          toggleDocumentData: this.toggleDocumentData,
          currentInvoice: this.state.factorInvoice,
          toggleMarkIllegibleData,
          toggleClientDebtorCheck: this.toggleClientDebtorOnBol,
          savingInvoice: this.state.saving,
          allowsEditing: true,
          expandBrowser: this.expandOrCompressBrowser,
          browserExpanded: this.state.browserExpanded,
          additionalComponents: additionalBrowserComponents(this.state),
          initialSelectedComponent: initialDocumentBrowserComponent(this.props),
          allowsEditingPodStatus: true
        }
      ) });
    });
    __publicField(this, "expandOrCompressBrowser", () => {
      this.setState((prevState) => ({
        browserExpanded: !prevState.browserExpanded
      }));
    });
    const settings = Api.Account.currentSettings();
    const setting = settings ? settings["client_notes_sidebar_display"] : void 0;
    const initialSidebarOpen = setting === "expanded";
    this.state = {
      loaded: false,
      documentBatches: [],
      browserExpanded: false,
      continueWithoutInvoiceInformation: false,
      reviewingAuditFlags: false,
      saving: false,
      viewingActivity: false,
      sidebarOpen: initialSidebarOpen,
      carrierData: null
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.params.factorInvoiceId !== prevProps.params.factorInvoiceId) {
      this.updateData(this.props);
    }
  }
  componentWillUnmount() {
    $(DataStoreService).off(
      "DataStoreService:documentPageReplaced",
      this.handlePageReplaced
    );
    $(DataStoreService).off(
      "DataStoreService:documentGroupUpdated",
      this.handleDocumentGroupUpdated
    );
    $(DataStoreService).off(
      "DataStoreService:documentBatchUpdated",
      this.handleDocumentBatchUpdated
    );
    hotkeys.unlistenInComponent(this);
  }
  componentDidMount() {
    $(DataStoreService).on(
      "DataStoreService:documentPageReplaced",
      this.handlePageReplaced
    );
    $(DataStoreService).on(
      "DataStoreService:documentGroupUpdated",
      this.handleDocumentGroupUpdated
    );
    $(DataStoreService).on(
      "DataStoreService:documentBatchUpdated",
      this.handleDocumentBatchUpdated
    );
    this.updateData(this.props);
    if (!this.props.embedded) {
      hotkeys.listenInComponent(this, AccountsPayable, {
        nextPage: _.partial(this.changePage, "next"),
        prevPage: _.partial(this.changePage, "previous"),
        togglePOD: this.togglePOD
      });
    }
  }
  render() {
    if (this.state.loaded) {
      const rootClassName = this.props.embedded ? "factor-invoice-embed" : void 0;
      return /* @__PURE__ */ jsx(
        "div",
        {
          "data-component": "FactorInvoiceExtractDataPage",
          className: rootClassName,
          children: /* @__PURE__ */ jsxs("div", { className: "document-container", children: [
            this.props.embedded ? null : header(this.props, this.state),
            this.props.embedded ? null : this.possibleIndexerProgressBar(),
            this.mainContent(),
            this.props.embedded ? null : /* @__PURE__ */ jsx("div", { id: "presence", children: /* @__PURE__ */ jsx(
              PresenceList,
              {
                location: this.props.location,
                batchId: documentBatchId(this.props) || originalDocumentBatchId(this.props)
              }
            ) })
          ] })
        }
      );
    } else {
      return /* @__PURE__ */ jsx(WaitingSpinner, { when: true });
    }
  }
}
export default FactorInvoiceExtractDataPage;
